module.exports = __webpack_public_path__ + "img/main-gallery1-mob.4872470b.webp";